import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=22099929&"
import script from "./afterDetail.vue?vue&type=script&lang=js&"
export * from "./afterDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterDetail.vue?vue&type=style&index=0&id=22099929&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22099929')) {
      api.createRecord('22099929', component.options)
    } else {
      api.reload('22099929', component.options)
    }
    module.hot.accept("./afterDetail.vue?vue&type=template&id=22099929&", function () {
      api.rerender('22099929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Urbanwarehouse/afterDetail.vue"
export default component.exports